import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function ConsumerForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditing = !!id;
  const [barangays, setBarangays] = useState([]);
  const [form, setForm] = useState({ account_code: '', name: '', barangay_id: '', address: '', mobile: '', consumer_type: 'Residential', status: 'Active' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/barangays').then(r => setBarangays(r.data));
    if (isEditing) {
      api.get(`/consumers/${id}`).then(r => {
        const c = r.data.consumer;
        setForm({ account_code: c.account_code, name: c.name, barangay_id: String(c.barangay_id), address: c.address || '', mobile: c.mobile || '', consumer_type: c.consumer_type, status: c.status });
      });
    }
  }, [id, isEditing]);

  const fetchNextCode = async (barangayId) => {
    if (!barangayId || isEditing) return;
    const r = await api.get(`/consumers/next_code/${barangayId}`);
    setForm(f => ({ ...f, account_code: r.data.next_code || f.account_code }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true); setError('');
    try {
      const data = { ...form, barangay_id: parseInt(form.barangay_id) };
      if (isEditing) await api.put(`/consumers/${id}`, data);
      else await api.post('/consumers', data);
      navigate(isEditing ? `/consumers/${id}` : '/consumers');
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    }
    setSaving(false);
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <div>
      <h1 className="page-title">{isEditing ? 'Edit Consumer' : 'Add Consumer'}</h1>
      {error && <div style={{ background: '#fde', color: '#d32f2f', padding: 12, borderRadius: 6, marginBottom: 16 }}>{error}</div>}
      <div className="card" style={{ maxWidth: 600 }}>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="label">Barangay *</label>
            <select className="input" value={form.barangay_id} onChange={e => { set('barangay_id', e.target.value); fetchNextCode(e.target.value); }} required>
              <option value="">Select...</option>
              {barangays.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="label">Account Code *</label>
            <input className="input" value={form.account_code} onChange={e => set('account_code', e.target.value)} required readOnly={isEditing} />
          </div>
          <div className="form-group">
            <label className="label">Full Name *</label>
            <input className="input" value={form.name} onChange={e => set('name', e.target.value.toUpperCase())} required />
          </div>
          <div className="form-group">
            <label className="label">Address</label>
            <input className="input" value={form.address} onChange={e => set('address', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="label">Mobile Number</label>
            <input className="input" value={form.mobile} onChange={e => set('mobile', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="label">Consumer Type</label>
            <select className="input" value={form.consumer_type} onChange={e => set('consumer_type', e.target.value)}>
              <option>Residential</option><option>Commercial</option><option>Industrial</option>
            </select>
          </div>
          {isEditing && (
            <div className="form-group">
              <label className="label">Status</label>
              <select className="input" value={form.status} onChange={e => set('status', e.target.value)}>
                <option>Active</option><option>Inactive</option><option>Disconnected</option>
              </select>
            </div>
          )}
          <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Saving...' : (isEditing ? 'Update' : 'Add Consumer')}</button>
        </form>
      </div>
    </div>
  );
}
